import type { ToolBadgeSpec } from '../types.js';

/** Simple non-expandable specs for tools that just produce a label + icon. */

export const getWeatherSpec: ToolBadgeSpec = {
  toolName: 'getWeather',
  icon: 'partly_cloudy_day',
  label: (_, active) => (active ? 'Checking the weather' : 'Checked the weather'),
};

export const updateTripSpec: ToolBadgeSpec = {
  toolName: 'updateTrip',
  icon: 'trip',
  label: (_, active) => (active ? 'Updating trip details' : 'Updated trip details'),
  activitySummary: { label: (_, active) => (active ? 'Updating your trip' : 'Updated your trip') },
};

export const fetchSabrePricesBatchedSpec: ToolBadgeSpec = {
  toolName: 'fetchSabrePricesBatched',
  aliases: ['sabreGetBulkHotelPrices'],
  icon: 'toll',
  label: (_, active) => (active ? 'Getting hotel prices' : 'Fetched hotel prices'),
};

/** Legacy sabreGetRoomRates / getHotelRoomsWithRates — historical chat data only. */
export const legacySabreRoomRatesSpec: ToolBadgeSpec = {
  toolName: 'sabreGetRoomRates',
  aliases: ['getHotelRoomsWithRates'],
  icon: 'hotel',
  label: (_, active) => (active ? 'Getting room rates' : 'Fetched room rates'),
  activitySummary: { key: 'roomSearch', label: (_, active) => (active ? 'Searching for rooms' : 'Searched for rooms') },
};
